import { render, staticRenderFns } from "./EditAboutElections.vue?vue&type=template&id=783ee8ca&scoped=true"
import script from "./EditAboutElections.vue?vue&type=script&lang=js"
export * from "./EditAboutElections.vue?vue&type=script&lang=js"
import style0 from "./EditAboutElections.vue?vue&type=style&index=0&id=783ee8ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783ee8ca",
  null
  
)

export default component.exports